import { api } from '@/lib/http-client';
import type { ConversationBotUpdate } from '@/types/conversations';

/**
 * Módulo 4 — Motor de IA: lo poco que el dashboard necesita de él.
 *
 * `PATCH /api/tenants/:tenantId/conversations/:conversationId/bot` (**solo ADMIN**) es el handoff
 * del inbox: `{ botActivo: false }` pausa el bot en ESA conversación —desde ahí contesta el equipo
 * humano y la conversación aparece como "requiere atención"— y `{ botActivo: true }` se la devuelve
 * al bot. Vive en `ai-engine` y no en `conversations` porque es comportamiento del motor, no
 * lectura del dashboard (ver la cabecera de `conversations.routes.ts`); la ruta sí es de la misma
 * familia, así que la pantalla del inbox lo consume como una acción más.
 *
 * Devuelve la fila CRUDA de `conversations` (ver `ConversationBotUpdate`), no la tarjeta del
 * inbox: el hook que lo llama reescribe el resumen en caché.
 */
export function setConversationBotActive(
  tenantId: string,
  conversationId: string,
  botActivo: boolean,
): Promise<ConversationBotUpdate> {
  return api.patch<ConversationBotUpdate>(
    `/api/tenants/${tenantId}/conversations/${conversationId}/bot`,
    { botActivo },
  );
}
